import {
  $declineSigningRequest,
  $getAvailableSignersOptions,
  $getDocumentConvertionStatus,
  $getDocumentPreviewPages,
  $getDocumentShareUrl,
  $getEmbedDocumentPreviewPages,
  $getSignerDocument,
  $getSigningDocument,
  $getSigningUrl,
  $sendCodeAccess,
  $sendDocumentOut,
  $sendOutEmbedDocument,
  $sendReminders,
  $sendSignatoryOpened,
  $shareDocument,
  $submitSignedDocument,
  $unlinkSigningReminders,
  declineSigningRequest,
  finishDocumentSigning,
  getAvailableSignersOptions,
  getDocumentConvertionStatus,
  getDocumentPreviewPages,
  getDocumentShareUrl,
  getEmbedDocumentPreviewPages,
  getSignerDocument,
  getSigningDocument,
  getSigningUrl,
  initDocumentSigning,
  sendCodeAccess,
  sendDocumentOut,
  sendOutEmbedDocument,
  sendReminders,
  sendSignatoryOpened,
  shareDocument,
  submitSignedDocument,
  unlinkSigningReminders,
} from './actionCreators';
import sagas from './sagas';

export default {
  sagas,
  actions: {
    initDocumentSigning,
    finishDocumentSigning,
    getSignerDocument,
    getSigningDocument,
    submitSignedDocument,
    declineSigningRequest,
    getAvailableSignersOptions,
    sendDocumentOut,
    sendReminders,
    sendSignatoryOpened,
    getDocumentPreviewPages,
    getDocumentShareUrl,
    shareDocument,
    getDocumentConvertionStatus,
    sendCodeAccess,
    getSigningUrl,
    unlinkSigningReminders,
    sendOutEmbedDocument,
    getEmbedDocumentPreviewPages,
  },
};

export const $actions = {
  getSignerDocument: $getSignerDocument,
  getSigningDocument: $getSigningDocument,
  submitSignedDocument: $submitSignedDocument,
  declineSigningRequest: $declineSigningRequest,
  getAvailableSignersOptions: $getAvailableSignersOptions,
  sendDocumentOut: $sendDocumentOut,
  sendReminders: $sendReminders,
  sendSignatoryOpened: $sendSignatoryOpened,
  getDocumentPreviewPages: $getDocumentPreviewPages,
  getDocumentShareUrl: $getDocumentShareUrl,
  shareDocument: $shareDocument,
  getDocumentConvertionStatus: $getDocumentConvertionStatus,
  sendCodeAccess: $sendCodeAccess,
  getSigningUrl: $getSigningUrl,
  unlinkSigningReminders: $unlinkSigningReminders,
  sendOutEmbedDocument: $sendOutEmbedDocument,
  getEmbedDocumentPreviewPages: $getEmbedDocumentPreviewPages,
};
